import React, { useState } from "react";
import { ArrowDown } from "lucide-react";
import { useLang } from "@/i18n";
import { HOME_COPY as C } from "@/data/homeContent";
import { HomeHeroScenes } from "./HomeHeroScenes";
import { BookButton } from "./HomeBookings";
import { RitualWordmark } from "./RitualWordmark";

export const HomeHero = () => {
  const { t } = useLang();
  const [brandReady, setBrandReady] = useState(false);
  return <section className="rh-hero" aria-labelledby="home-title" data-testid="home-hero">
    <HomeHeroScenes />
    <div className="rh-hero-shade" />
    <div className="rh-hero-center">
      <h1 id="home-title" className="sr-only" data-testid="home-title">{t(C.heroTitle)}</h1>
      <div className={`rh-hero-brand ${brandReady ? "is-ready" : ""}`} data-testid="home-hero-brand"><RitualWordmark testId="home-hero-wordmark" onLoad={() => setBrandReady(true)} /></div>
      <p className="rh-hero-line" data-testid="home-hero-line">{t(C.heroLine)}</p>
      <div className="rh-hero-actions">
        <BookButton testId="hero-reservar" />
        <a href="#ritual" className="rh-hero-discover" data-testid="hero-descubrir">{t(C.discover)}<ArrowDown size={14} strokeWidth={1.4} /></a>
      </div>
    </div>
  </section>;
};